import { useMemo } from "react";
import {
    AXNUICustomLandingPage
} from "@iddataweb/idw-common-ui/containers";
import { PolicyDecisionResultTypes } from "@iddataweb/idw-common-ui/enums";
import {
    AXNUIContent,
    AXNUILayout,
    AXNUITheme
} from "@iddataweb/idw-common-ui/types";
import {
    getLandingPageContentAndLayout,
    getMatchesCustomRedirectUrl,
    getMatchesStaticRedirectUrl
} from "@iddataweb/idw-common-ui/utils";

type AXNUIThemingLandingPageProps = {
    axnuiContent: AXNUIContent;
    axnuiLayout: AXNUILayout;
    axnuiTheme: AXNUITheme;
    selectedLandingPage: string;
    selectedLandingPagePolicyDecisionResultType: PolicyDecisionResultTypes;
};

export const AXNUIThemingLandingPage = (props: AXNUIThemingLandingPageProps) => {
    const {
        axnuiContent,
        axnuiLayout,
        axnuiTheme,
        selectedLandingPage,
        selectedLandingPagePolicyDecisionResultType
    } = props;

    const {
        approveMessageHTML,
        asiLabel,
        denyMessageHTML,
        showAsiLabel,
        noDecisionMessage
    } = useMemo(() => {
        return getLandingPageContentAndLayout(axnuiContent, axnuiLayout, selectedLandingPage)
    }, [axnuiContent, axnuiLayout, selectedLandingPage]);

    const showStaticLandingPage: boolean = useMemo(() => {
        return getMatchesStaticRedirectUrl(selectedLandingPage);
    }, [selectedLandingPage]);

    const showCustomLandingPage: boolean = useMemo(() => {
        return getMatchesCustomRedirectUrl(selectedLandingPage);
    }, [selectedLandingPage]);

    return (
        <div>
            {showCustomLandingPage && (
                <AXNUICustomLandingPage
                    approveMessageHTML={approveMessageHTML}
                    denyMessageHTML={denyMessageHTML}
                    asi={"0000-0000-0000-0000-0000"}
                    asiLabel={asiLabel}
                    showAsiLabel={showAsiLabel}
                    policyDecision={selectedLandingPagePolicyDecisionResultType}
                    noDecisionMessage={noDecisionMessage}
                    formPanelContent={axnuiContent.formPanel}
                    formPanelLayout={axnuiLayout.formPanel}
                    formPanelTheme={axnuiTheme.formPanel}
                    defaultFontFamily={axnuiTheme.general.font}
                    defaultTextColor={axnuiTheme.general.mainTextColor}
                    idpName={null}
                    logoPosition={null}
                    logoUrl={null}
                    relyingPartyName={null}
                    useThemedUI={true}
                />
            )}
            {!showCustomLandingPage && showStaticLandingPage && (
                <>
                    Endpoint specific data will appear here
                </>
            )}
        </div>
    );
};